
/**
 * 
 *   const delayedQuery = React.useCallback(debounce((f: IOrderListFilter) => { loadData(f) },300 ), []);
 * 
 * */
export function debounce<T extends Function>(fn: T, timeout: number): T {
    let timer: NodeJS.Timer;
    return function (...args: any[]): any {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, timeout);

    } as any;
}